import { render, staticRenderFns } from "./IconQuestion.vue?vue&type=template&id=0bfd91ae"
import script from "./IconQuestion.vue?vue&type=script&lang=js"
export * from "./IconQuestion.vue?vue&type=script&lang=js"
import style0 from "./IconQuestion.vue?vue&type=style&index=0&id=0bfd91ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports